import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { RUNTIME_TABS, type RuntimeTab } from '@/features/admin/shared/tabs';
import { RuntimeDetailPage } from '@/features/admin/runtimes/runtime-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Détail d'un runtime (porting README #41). L'onglet actif vit dans l'URL (`?tab=`). */
export const Route = createFileRoute('/$tenant/runtimes/$runtimeId/')({
  validateSearch: (search: Record<string, unknown>): { tab: RuntimeTab } => ({
    tab: RUNTIME_TABS.parse(search['tab']),
  }),
  component: RuntimeRoute,
});

function RuntimeRoute() {
  const { tenant, runtimeId } = Route.useParams();
  const { tab } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="runtimes"
      crumbs={[{ label: t('nav.items.runtimes') }, { label: runtimeId, mono: true }]}
    >
      <RuntimeDetailPage
        tenantId={tenant}
        runtimeId={runtimeId}
        tab={tab}
        onTabChange={(next) => void navigate({ search: { tab: next }, replace: true })}
      />
    </ConsoleShell>
  );
}
